import React, { useEffect } from 'react';
import { useFormContext, useFieldArray, useWatch } from 'react-hook-form';
import { FileUpload } from '@/components/FileViewer';
import { INVOICE_UPLOAD_URL } from '@/config';
import { IFile, IVendorBill } from '@/types';

const AttachmentsSection: React.FC<{
  initialData: IVendorBill | null;
}> = ({ initialData }) => {
  const { control, setValue } = useFormContext<IVendorBill>();

  const { append, remove } = useFieldArray({
    control,
    name: 'files',
  });

  const { append: appendDeletedFile } = useFieldArray({
    control,
    name: 'deletedfiles' as any,
  });

  const currentFiles = useWatch({ control, name: 'files' }) as any[];

  useEffect(() => {
    if (initialData?.files?.length) {
      setValue('files', initialData.files);
    }
  }, [initialData, setValue]);

  return (
    <FileUpload
      files={currentFiles || []}
      onAdd={(acceptedFiles) => {
        acceptedFiles.forEach((file) => {
          const fileId = Math.random().toString(36).substring(7);
          const previewUrl = URL.createObjectURL(file);

          const fakeIFile: IFile = {
            file,
            id: fileId,
            preview: previewUrl,
            isNew: true,
            fieldname: 'files',
            originalname: file.name,
            encoding: '7bit',
            mimetype: file.type,
            destination: '',
            filename: file.name,
            path: '',
            size: file.size,
            url: previewUrl,
          };

          append(fakeIFile as any);
        });
      }}
      onRemove={(index) => {
        const fileToRemove = currentFiles?.[index];
        if (fileToRemove?.originalname && fileToRemove?.filename) {
          appendDeletedFile(fileToRemove.filename as any);
        }
        remove(index);
      }}
      uploadUrl={INVOICE_UPLOAD_URL}
      accept={{
        'image/*': ['.jpeg', '.jpg', '.png'],
        'application/pdf': ['.pdf'],
        'application/msword': ['.doc'],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
        'application/vnd.ms-excel': ['.xls'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      }}
      maxSize={20971520}
    />
  );
};

export default AttachmentsSection;
